/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * One bar of the experience distribution.
 *
 * ``min_years`` is inclusive, ``max_years`` exclusive, and the buckets are
 * contiguous and equal-width, so the last one's ``max_years`` is the top of the
 * domain: as far as the panel's range slider can reach before it means "no
 * upper bound" at all. Width is chosen per job, not fixed, so the bars describe
 * the careers the job actually holds.
 */
export interface PipelineExperienceBucket {
  /** @minimum 0 */
  min_years: number;
  /** @minimum 0 */
  max_years: number;
  /** @minimum 0 */
  count: number;
}
